import Form from './Form';

// export types
export type { FormProps } from './Form';
export type { FormInstance } from './hooks/useFormRef';
export type { Resolver, ResolverResult } from './resolvers';

// export components
export { Form };
export default Form;
